var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptoBasicsTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_52989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4576 11.8172C62.4576 -8.68491 36.6421 5.56084 23.6238 4.98472C18.7263 4.76797 7.34751 -3.78916 2.74051 2.01559C-3.18824 9.48572 14.798 20.6592 14.6128 30.1943C14.448 38.6763 9.38376 46.9145 15.0664 55.0426C25.6303 70.1527 46.3095 65.09 46.3095 47.7582C46.3095 25.6955 62.4576 23.1486 62.4576 11.8172Z",
    fill: "url(#paint0_linear_1543_52989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.108 13.4613L19.7793 9.4375",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7795 11.246C20.7784 11.246 21.5882 10.4362 21.5882 9.43729C21.5882 8.43835 20.7784 7.62854 19.7795 7.62854C18.7805 7.62854 17.9707 8.43835 17.9707 9.43729C17.9707 10.4362 18.7805 11.246 19.7795 11.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7795 11.246C20.7784 11.246 21.5882 10.4362 21.5882 9.43729C21.5882 8.43835 20.7784 7.62854 19.7795 7.62854C18.7805 7.62854 17.9707 8.43835 17.9707 9.43729C17.9707 10.4362 18.7805 11.246 19.7795 11.246Z",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6373 16.8462L11.8086 10.5962",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8088 12.4053C12.8077 12.4053 13.6175 11.5955 13.6175 10.5966C13.6175 9.59765 12.8077 8.78784 11.8088 8.78784C10.8098 8.78784 10 9.59765 10 10.5966C10 11.5955 10.8098 12.4053 11.8088 12.4053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8088 12.4053C12.8077 12.4053 13.6175 11.5955 13.6175 10.5966C13.6175 9.59765 12.8077 8.78784 11.8088 8.78784C10.8098 8.78784 10 9.59765 10 10.5966C10 11.5955 10.8098 12.4053 11.8088 12.4053Z",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.7793 14.2459C20.1915 14.2459 20.5701 14.1065 20.8742 13.8745L25.7723 16.9888C25.8763 17.0548 25.9923 17.0864 26.1071 17.0864C26.3137 17.0864 26.516 16.984 26.6352 16.7967C26.8203 16.5054 26.7343 16.1192 26.4431 15.9339L21.5466 12.8208C21.5733 12.6972 21.5882 12.569 21.5882 12.4373C21.5882 11.4383 20.7785 10.6285 19.7795 10.6285C18.7805 10.6285 17.9707 11.4383 17.9707 12.4373C17.9706 13.436 18.7805 14.2459 19.7793 14.2459Z",
    fill: "#F79009"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.8409 26.363L48.0286 8.33609C47.7254 7.71584 46.9769 7.45884 46.3566 7.76209L22.1969 19.5725C22.148 19.4723 22.0735 19.3831 21.9726 19.3188L13.5759 13.9795C13.6025 13.856 13.6174 13.7281 13.6174 13.5966C13.6174 12.5977 12.8075 11.7878 11.8086 11.7878C10.8098 11.7878 9.99975 12.5976 9.99975 13.5966C9.99975 14.5956 10.8095 15.4053 11.8085 15.4053C12.2209 15.4053 12.5998 15.2657 12.904 15.0335L20.9785 20.168L18.0781 21.5858C17.4579 21.889 17.2009 22.6376 17.5041 23.2578L19.687 27.7232H17.0312C15.6505 27.7232 14.5312 28.8425 14.5312 30.2232V36.2778C10.3891 36.2778 7.03125 39.6357 7.03125 43.7778C7.03125 47.92 10.3891 51.2778 14.5312 51.2778V56.8652C14.5312 58.246 15.6505 59.3652 17.0312 59.3652H50.1025C51.4832 59.3652 52.6025 58.246 52.6025 56.8652V48.9082C53.2158 48.8283 53.6898 48.3051 53.6898 47.67V39.4183C53.6898 38.7833 53.2158 38.2601 52.6025 38.1801V30.2231C52.6025 30.0931 52.5895 29.9665 52.5704 29.8418L56.2667 28.035C56.8871 27.7317 57.1441 26.9831 56.8409 26.363Z",
    fill: "#F79009"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2669 25.035L27.9884 38.8586C27.3682 39.1619 26.6197 38.9048 26.3164 38.2846L17.5042 20.2579C17.2011 19.6376 17.4581 18.8891 18.0782 18.5859L46.3568 4.76213C46.9771 4.45901 47.7256 4.71601 48.0288 5.33613L56.8411 23.3629C57.1442 23.9831 56.8872 24.7318 56.2669 25.035Z",
    fill: "#FFD194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8077 6.92664L18.2832 21.8491L20.7517 26.8986L51.2762 11.9761L48.8077 6.92664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2669 25.035L27.9884 38.8586C27.3682 39.1619 26.6197 38.9048 26.3164 38.2846L17.5042 20.2579C17.2011 19.6376 17.4581 18.8891 18.0782 18.5859L46.3568 4.76213C46.9771 4.45901 47.7256 4.71601 48.0288 5.33613L56.8411 23.3629C57.1442 23.9831 56.8872 24.7318 56.2669 25.035Z",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1094 16.4578L49.4549 15.3112",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7891 21.0508L50.6266 17.7083",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2843 29.7268C28.8926 29.7268 27.5959 28.9589 26.9001 27.723L23.6175 21.8922C22.9218 20.6562 22.9218 19.1207 23.6175 17.8848L26.9003 12.0538C27.5959 10.8179 28.8926 10.05 30.2843 10.05H36.8495C38.2413 10.05 39.5379 10.8179 40.2338 12.0538L43.5163 17.8847C44.212 19.1207 44.212 20.6562 43.5164 21.892L40.2336 27.723C39.538 28.9589 38.2413 29.7268 36.8495 29.7268H30.2843Z",
    fill: "#FFD194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2843 29.7268C28.8926 29.7268 27.5959 28.9589 26.9001 27.723L23.6175 21.8922C22.9218 20.6562 22.9218 19.1207 23.6175 17.8848L26.9003 12.0538C27.5959 10.8179 28.8926 10.05 30.2843 10.05H36.8495C38.2413 10.05 39.5379 10.8179 40.2338 12.0538L43.5163 17.8847C44.212 19.1207 44.212 20.6562 43.5164 21.892L40.2336 27.723C39.538 28.9589 38.2413 29.7268 36.8495 29.7268H30.2843Z",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0843 12.4219H30.0505C29.6264 12.4219 29.2353 12.6505 29.0273 13.0201L25.485 19.3123C25.2836 19.6699 25.2836 20.1067 25.485 20.4644L29.0273 26.7565C29.2353 27.126 29.6264 27.3547 30.0505 27.3547H37.0843C37.5084 27.3547 37.8995 27.1261 38.1075 26.7565L41.6498 20.4644C41.8511 20.1067 41.8511 19.6699 41.6498 19.3123L38.1075 13.0201C37.8994 12.6505 37.5083 12.4219 37.0843 12.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4521 15.0577H32.9766V24.7189",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8465 24.7189L28.127 19.8882L30.8465 21.005V15.0577",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9766 19.7207H34.2948",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4531 17.3649V24.719",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0879 17.2977H37.8179L39.0598 19.5644",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1025 56.3651H17.0313C15.6505 56.3651 14.5312 55.2459 14.5312 53.8651V27.2231C14.5312 25.8424 15.6505 24.7231 17.0313 24.7231H50.1025C51.4832 24.7231 52.6025 25.8424 52.6025 27.2231V53.8651C52.6025 55.2459 51.4832 56.3651 50.1025 56.3651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8506 24.7231H17.0313C15.6505 24.7231 14.5312 25.8424 14.5312 27.2231V35.6765",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 51.888V53.8653C14.5312 55.246 15.6505 56.3653 17.0313 56.3653H50.1025C51.4833 56.3653 52.6025 55.246 52.6025 53.8653V27.2231C52.6025 25.8424 51.4833 24.7231 50.1025 24.7231H48.562",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.041 27.8481H19.791",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6855 27.8481H47.2824",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "11.57 23.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7285 27.8481H49.4785V28.5981",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4785 30.9261V33.2541",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "9.31 18.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4785 34.4181V35.1681",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4785 45.9194V46.6694",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4785 48.9979V51.3264",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "9.31 18.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4785 52.4907V53.2407H48.7285",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8352 53.2407H21.2383",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "11.57 23.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.791 53.2407H19.041",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4391 45.92H44.1875C42.1164 45.92 40.4375 44.2411 40.4375 42.17V38.9183C40.4375 36.8472 42.1164 35.1683 44.1875 35.1683H52.4391C53.1295 35.1683 53.6891 35.728 53.6891 36.4183V44.67C53.6891 45.3603 53.1295 45.92 52.4391 45.92Z",
    fill: "#FFD194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4391 45.92H44.1875C42.1164 45.92 40.4375 44.2411 40.4375 42.17V38.9183C40.4375 36.8472 42.1164 35.1683 44.1875 35.1683H52.4391C53.1295 35.1683 53.6891 35.728 53.6891 36.4183V44.67C53.6891 45.3603 53.1295 45.92 52.4391 45.92Z",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7559 42.1067C45.6188 42.1067 46.3184 41.4071 46.3184 40.5442C46.3184 39.6812 45.6188 38.9817 44.7559 38.9817C43.8929 38.9817 43.1934 39.6812 43.1934 40.5442C43.1934 41.4071 43.8929 42.1067 44.7559 42.1067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 48.2777C18.6734 48.2777 22.0313 44.9198 22.0313 40.7777C22.0313 36.6356 18.6734 33.2777 14.5312 33.2777C10.3891 33.2777 7.03125 36.6356 7.03125 40.7777C7.03125 44.9198 10.3891 48.2777 14.5312 48.2777Z",
    fill: "#FFD194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 46.4027C17.6379 46.4027 20.1563 43.8843 20.1563 40.7777C20.1563 37.6711 17.6379 35.1527 14.5312 35.1527C11.4246 35.1527 8.90625 37.6711 8.90625 40.7777C8.90625 43.8843 11.4246 46.4027 14.5312 46.4027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 48.2777C18.6734 48.2777 22.0313 44.9198 22.0313 40.7777C22.0313 36.6356 18.6734 33.2777 14.5312 33.2777C10.3891 33.2777 7.03125 36.6356 7.03125 40.7777C7.03125 44.9198 10.3891 48.2777 14.5312 48.2777Z",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8757 42.9117H16.4722L15.9445 40.7777H13.1194L12.5918 38.6437H16.1883",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 42.9117V43.9027",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 37.6527V38.6437",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1289 6.92798C28.7847 6.92798 29.3164 6.39632 29.3164 5.74048C29.3164 5.08464 28.7847 4.55298 28.1289 4.55298C27.4731 4.55298 26.9414 5.08464 26.9414 5.74048C26.9414 6.39632 27.4731 6.92798 28.1289 6.92798Z",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 28.9355C10.1246 28.9355 10.6562 28.4039 10.6562 27.748C10.6562 27.0922 10.1246 26.5605 9.46875 26.5605C8.81291 26.5605 8.28125 27.0922 8.28125 27.748C8.28125 28.4039 8.81291 28.9355 9.46875 28.9355Z",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0312 21.0556L11.5938 19.6182L10.1563 21.0556L11.5938 22.4931L13.0312 21.0556Z",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8437 31.5075L58.4062 30.0701L56.9688 31.5075L58.4063 32.945L59.8437 31.5075Z",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8437 49.2155L58.4062 47.7781L56.9688 49.2155L58.4062 50.653L59.8437 49.2155Z",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1543_52989",
    x1: 6.27132,
    y1: 46.7769,
    x2: 54.7142,
    y2: -1.66595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8CA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE2BB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_52989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoBasicsTestIcon);
export default __webpack_public_path__ + "static/media/crypto-basics-test-icon.ea096fc18d9c9675f4c1dd25b9f5c276.svg";
export { ForwardRef as ReactComponent };